import React from "react"
import clsx from "clsx"

import { useTimezone } from "hooks/useTimezone"

import { AffiliateReferralLinkRow } from "services/user/type"

import { formatFiatCurrency } from "util/formatter"

type Props = {
  links: AffiliateReferralLinkRow[]
}

export const UserAffiliateReferredUsersTable: React.FC<Props> = ({ links }) => {
  const { formatDateTime } = useTimezone()

  if (!links?.length) {
    return <div className="p-4 text-sm opacity-70">No referred users for this code.</div>
  }

  return (
    <div className="p-4">
      <div className="mb-3 text-sm font-semibold">Referred users</div>

      <div className="overflow-x-auto rounded-lg border border-[rgba(0,0,0,0.06)] dark:border-[rgba(255,255,255,0.08)]">
        <table className="w-full min-w-[900px] bg-white dark:bg-[#0C0C1A]">
          <thead className="bg-[rgba(139,92,246,0.06)] dark:bg-[rgba(139,92,246,0.08)]">
            <tr className="text-xs uppercase tracking-wide text-[rgba(6,7,21,0.6)] dark:text-white/70">
              <th className="py-3 px-3 text-left">Username</th>
              <th className="py-3 px-3 text-left">Active</th>
              <th className="py-3 px-3 text-left">Deposited</th>
              <th className="py-3 px-3 text-left">Last deposit</th>
              <th className="py-3 px-3 text-left">Last deposit date</th>
              <th className="py-3 px-3 text-left">Earned</th>
              <th className="py-3 px-3 text-left">Est. earned</th>
            </tr>
          </thead>

          <tbody>
            {links.map((l) => (
              <tr
                key={l.id}
                className={clsx(
                  "border-t border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.08)]",
                  "text-sm text-[rgba(6,7,21,0.7)] dark:text-white/70"
                )}
              >
                <td className="py-3 px-3">{l.username ?? l.user_id}</td>
                <td className="py-3 px-3">{l.active ? "YES" : "NO"}</td>
                <td className="py-3 px-3">{formatFiatCurrency(l.deposited, "0")} USD</td>
                <td className="py-3 px-3">{formatFiatCurrency(l.last_deposit_amount, "0")} USD</td>
                <td className="py-3 px-3">{l.last_deposit_date ? formatDateTime(l.last_deposit_date) : "-"}</td>
                <td className="py-3 px-3">{formatFiatCurrency(l.earned_usd, "0")} USD</td>
                <td className="py-3 px-3">{formatFiatCurrency(l.earned_estimated_usd, "0")} USD</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
